import { Link } from "react-router-dom";
import { useVenueState, useBrowseGroups, useClosedStateMessage } from "@touchscreen/hooks";
import { Artwork } from "@touchscreen/brand-kit";
import "./BrowseScreen.css";

/**
 * The landing screen. Where most punters start — must be immediately usable with no explanation.
 */
export function BrowseScreen(): React.JSX.Element {
  const { requestsOpen, requestsClosedReason, nextTransitionAt } = useVenueState();
  const closedMessage = useClosedStateMessage(requestsClosedReason, nextTransitionAt);

  const { data: groups, isError: error } = useBrowseGroups();

  return (
    <div className="browse-screen">
      {!requestsOpen ? <div className="browse-screen__banner">{closedMessage}</div> : null}

      <h1 className="browse-screen__title">Browse</h1>

      {error ? <p className="browse-screen__hint">Browsing isn't available right now.</p> : null}

      <div className="browse-screen__list">
        {groups === undefined && !error
          ? Array.from({ length: 6 }, (_, i) => <div key={i} className="browse-screen__skeleton" />)
          : groups?.map((group) => (
              <Link key={group.id} to={`/groups/${group.id}`} className="browse-screen__group">
                <Artwork className="browse-screen__group-art" src={group.artwork_ref} />
              </Link>
            ))}
      </div>
    </div>
  );
}
